import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { MessageBar, MessageBarType, ProgressIndicator } from "@fluentui/react";
import formatNumber from "accounting-js/lib/formatNumber";
import {
  Badge,
  Button,
  List,
  Popconfirm,
  Skeleton,
  Tooltip,
  message,
  Typography,
  notification,
} from "antd";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";

import React, { createContext, useContext, useEffect } from "react";
import Scrollbars from "react-custom-scrollbars";
import { Edit2, Info, Plus, Trash, TrendingUp } from "react-feather";
import MaterialStore from "../store/materialstore";
import { AddChemical } from "./AddChemical";
import { StockHistoryForm } from "./StockHistoryForm";
import { StockHistoryList } from "./StockHistoryList";

const { Title } = Typography;

const materialStoreCtx = createContext(MaterialStore);
export const MaterialList = observer(() => {
  const materialStore = useContext(materialStoreCtx);

  useEffect(() => {
    async function loadChemicals() {
      await materialStore.loadchemicals();
    }
    loadChemicals();
  }, []);

  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Scrollbars style={{ height: "100vh", overflowX: "hidden" }}>
            {materialStore.isLoadingChemicals ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <List
                id="mtrlist"
                itemLayout="vertical"
                dataSource={[...materialStore.chemicals.values()]}
                size="small"
                style={{ width: "95%" }}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm10">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "16px",
                            color: "red",
                          }}
                        >
                          {`${materialStore.mainStore.assetContextName} Materials (Chemicals)`}
                        </Title>
                        <Badge count={materialStore.chemicals.size} />
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="add new chemical">
                          <Button
                            shape="circle"
                            icon={<PlusOutlined />}
                            type="primary"
                            onClick={(ev) => {
                              materialStore.showAddDialog = true;
                              materialStore.addChemicalAction = "add";
                              materialStore.addChemicalFormData = {};
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
                      <div className="ms-Grid-col ms-sm12">
                        <MessageBar messageBarType={MessageBarType.info}>
                          only admin can remove unused material(chemical)
                        </MessageBar>
                      </div>
                    </div>
                    {materialStore.isprocessing && (
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          {" "}
                          <ProgressIndicator
                            description="processing, please wait..."
                            styles={{ root: { textAlign: "center" } }}
                          ></ProgressIndicator>
                        </div>
                      </div>
                    )}
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    actions={
                      !item?.isSystemAdmin && [
                        <Tooltip title={`Restock ${item?.name} chemical`}>
                          <Button
                            type="link"
                            icon={<Plus size={20} color="#1890FF" />}
                            onClick={() => {
                              materialStore.selChem = item;
                              materialStore.showStockDialog = true;
                              materialStore.clearHistortyFormData();
                            }}
                          />
                        </Tooltip>,
                        <Tooltip title={`modify ${item?.name} chemical`}>
                          <Button
                            type="link"
                            icon={<Edit2 size={16} />}
                            onClick={() => {
                              try {
                                materialStore.addChemicalAction = "update";
                                materialStore.addChemicalFormData = toJS(item);
                                materialStore.showAddDialog = true;
                                console.log(item);
                                /* materialStore.removePriviledge(item);
                                message.success(
                                  `${item.name} chemical removal was successfull`
                                ); */
                              } catch (error) {
                                notification.error({
                                  message: "SPARS Feedback",
                                  description: `something went wrong  due to : ${error.message} `,
                                });
                              }
                            }}
                          />
                        </Tooltip>,
                        <Tooltip
                          title={`Delete ${item?.name.toLowerCase()} chemical`}
                        >
                          <Popconfirm
                            title={`Are you sure you want to remove ${item?.name} chemical？`}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              try {
                                /* materialStore.removePriviledge(item);
                                 message.success(
                                  `${item.name} chemical removal was successfull`
                                ); */
                              } catch (error) {
                                notification.error({
                                  message: "SPARS Feedback",
                                  description: `something went wrong  due to : ${error.message} `,
                                });
                              }
                            }}
                          >
                            <Button
                              type="link"
                              disabled
                              icon={<Trash size={16} />}
                            />
                          </Popconfirm>
                        </Tooltip>,

                        <Tooltip
                          title={`View ${item?.name.toLowerCase()} chemical stock history`}
                        >
                          <Button
                            type="link"
                            icon={<TrendingUp size={16} />}
                            onClick={async () => {
                              try {
                                materialStore.isprocessing = true;
                                materialStore.selChem = item;

                                await materialStore.loadStockHistory(item);
                                materialStore.showHistoryDialog = true;
                              } catch (error) {
                                notification.error({
                                  key: "error",
                                  message: "SPARS Feedback",
                                  description: error.message,
                                });
                              } finally {
                                materialStore.isprocessing = false;
                              }
                            }}
                          />
                        </Tooltip>,
                      ]
                    }
                  >
                    <List.Item.Meta
                      title={
                        <div className="ms-Grid" dir="ltr">
                          <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "14px",
                                  }}
                                >
                                  {item.name}
                                </div>
                                <Tooltip
                                  title={`current ${item?.name.toLowerCase()} available stock in ${
                                    item?.unit
                                  }`}
                                >
                                  <div className="pill">
                                    <span
                                      style={{
                                        color: "blue",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {formatNumber(item.stock, {
                                        precision: 2,
                                        thousand: ",",
                                      })}{" "}
                                      {item.unitAbbr}
                                    </span>
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      description={item.description}
                    />
                  </List.Item>
                )}
              />
            )}
          </Scrollbars>
          <AddChemical />
          <StockHistoryForm />
          <StockHistoryList />
        </div>
      </div>
    </div>
  );
});

